/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/** Utilities */
import { decryptUrlData, encryptUrlData } from '../../../../../services/CryptoService';

/** Custom Hooks */
import useDebounce from '../../../../../app/customHooks/useDebounce';

/** Common Components */
import MolGrid from '../../../../../components/grid/MolGrid';
import CardSection from '../../../../../components/ui/card/CardSection';

/** Configuration Files */
import { employeeTimesheetGridConfig } from './config/employeeTimesheetGridConfig.data';

/** RTK Query */
import { useGetTimeSheetByUserIdMutation } from '../../../../../app/services/timeSheetLogAPI';

const EmployeeTimesheet = () => {

  const { id } = useParams();
  const teamMember = id ? decryptUrlData(id) : 0;
  const navigate = useNavigate()

  const molGridRef = useRef();

  const [searchText] = useState("");
  const [dataSource, setDataSource] = useState(null);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);


  const debouncedSearch = useDebounce(searchText, 300);

  const [getTimeSheetByUserId, {
    isLoading: isTimeSheetByUserIdLoading,
    isSuccess: isTimeSheetByUserIdSuccess,
    data: timeSheetByUserIdData,
  }] = useGetTimeSheetByUserIdMutation();

  const getReviewTimeSheet = (pageObject, searchText) => {
    const req = {
      pagination: { pageNumber: pageObject.pageNumber, pageSize: pageObject.pageSize },
      filters: { searchText: searchText },
      userId: teamMember.userId
    }
    getTimeSheetByUserId(req);
  }

  const handlePageChange = (pageObject) => {
    setCurrentPage(pageObject.pageNumber || pageObject);
    setPageSize(pageObject.pageSize || 10)
    getReviewTimeSheet(pageObject, debouncedSearch);
  }

  const handleEditClick = (data) => {
    let userId = data?.userId;
    let startDate = data?.startDate;
    let endDate = data?.endDate;
   // setIsModelOpen(true);
    const navigationUrl = `/TimeSheet/ReviewTimeSheet/ReviewWeeklyTimesheet/${encryptUrlData({ userId: userId, name: teamMember.name, startDate: startDate, endDate: endDate })}`;
    if (userId) {
      window.open(navigationUrl, "_blank", "noopener,noreferrer");
    }
  }

  const handleBackToList = () => {
    navigate('/TimeSheet/ReviewTimeSheet/');
  }

  useEffect(() => {
    if (molGridRef.current && teamMember.userId) {
      getReviewTimeSheet(molGridRef.current.getDefulatPageObject(), debouncedSearch);
    }
  }, [teamMember.userId, debouncedSearch]);

  useEffect(() => {
    if (isTimeSheetByUserIdSuccess && timeSheetByUserIdData) {
      if (timeSheetByUserIdData.dataSource) {
        setDataSource(timeSheetByUserIdData.dataSource)
      }
      if (timeSheetByUserIdData.totalRecord) {
        setTotalRowCount(timeSheetByUserIdData.totalRecord)
      }
    }
  }, [isTimeSheetByUserIdSuccess, timeSheetByUserIdData]);

  const actionHandler = {
    EDIT: handleEditClick
  }

  return (
    <div className="timesheet-summary-list center-top-space">
      <div className="list-view-section">
        <div className="table-grid">
          <CardSection
            isContentLoading={isTimeSheetByUserIdLoading}
            cardTitle={`${teamMember?.name ? teamMember.name : "User"} : Time Sheet Summary`}
            rightButton={true}
            buttonClassName="dark-btn"
            titleButtonClick={handleBackToList}
            buttonText="Back"
            textWithIcon={true}
            iconName="lets-icons:back"
            fontIcon={true}
            searchInput={false}
            isShorting={false}
          // showListView={showListView}
          // showCardView={showCardView}
          // viewType={viewType}
          >
            <MolGrid
              ref={molGridRef}
              configuration={employeeTimesheetGridConfig}
              dataSource={dataSource}
              allowPagination={true}
              pagination={{
                totalCount: totalRowCount,
                pageSize: pageSize,
                currentPage: currentPage,
              }}
              isLoading={isTimeSheetByUserIdLoading}
              onPageChange={handlePageChange}
              onActionChange={actionHandler}
            />
          </CardSection>
        </div>
      </div>
    </div>
  )
}

export default EmployeeTimesheet